import type { ReactElement } from 'react'
import { cloneElement } from 'react'

import { FormControl, type IFormikFormControlProps } from './FormControl'
import { type INumberFieldProps } from '@ui/elements/NumberField'

export interface IWithFormControlNumberField extends Omit<
  IFormikFormControlProps,
  'children'
> {
  id: string
  name: string
  useFloatValue?: boolean
  children: ReactElement<INumberFieldProps>
}

export const WithFormControlNumberField = ({
  name,
  disabled,
  id,
  label,
  labelBadge,
  helperText,
  required,
  fullWidth = true,
  useFloatValue = false,
  children,
}: IWithFormControlNumberField) => {
  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      label={label}
      labelBadge={labelBadge}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
    >
      {({ value, handleChange, handleBlur, isSubmitting, error }) => {
        return cloneElement(children, {
          id,
          name,
          value,
          onValueChange: (values) => {
            const changeValue = useFloatValue ? values.floatValue : values.value

            handleChange(changeValue)

            if (children.props.onValueChange)
              children.props.onValueChange(values)
          },
          onBlur: handleBlur,
          error,
          disabled: isSubmitting || disabled,
        })
      }}
    </FormControl>
  )
}
